// src/experiments/flags.config.js
//
// Feature flags: plain switches with a code default and an optional remote
// override, read with getFlag() / useFlag() from src/experiments/flags.js.
// Unlike an experiment, a flag applies to everyone, crawlers included, fires
// no exposure, is not stamped into analytics and has no session freeze. Use a
// flag for a kill switch or a staged feature; use an experiment to measure.
//
// A remote value must have the same type as the default here (boolean,
// number or string). Unknown remote keys are ignored. Remove a flag by
// deleting it here and, if it was set, in the console.
export const FLAGS = {
  // SMS delivery of the one-time password. Off means every flow falls back
  // to email OTP. Read through ENABLE_OTP_SMS in questionEngineOtpHelpers.js.
  otp_sms: false,
};
